// Shared constants for Payment Terms (list, modal, detail page)

export const CANCELLATION_CATEGORY = 'Cancellation';
export const DEFAULT_PAYMENT_DUE = 'Days Prior to Departure';

export const PAYMENT_DUE_OPTIONS = [
    'On Booking Confirmation',
    'Date of Departure',
    'Days Prior to Departure',
    'Days after purchase',
    'Days after departure',
];

export const PAYMENT_TYPE_OPTIONS = [
    'Deposit',
    'Balance',
    'Second Payment',
    'Third Payment',
    'Fourth Payment',
];

export const CATEGORY_OPTIONS = ['Merchant', 'Guide', 'Influencer', CANCELLATION_CATEGORY];

// Stored values match the backend CancellationType enum used by the travel order cancel request
export const CANCELLATION_TYPE_OPTIONS = [
    { value: 'customer', label: 'Customer' },
    { value: 'organization', label: 'Organization' },
    { value: 'non_payment', label: 'Non-Payment' },
];

export const REFUND_METHOD_OPTIONS = ['Coupon', 'Direct Refund'];
export const STATUS_OPTIONS = ['Active', 'Inactive', 'Draft'];

export const getCancellationTypeLabel = (value) =>
    CANCELLATION_TYPE_OPTIONS.find((o) => o.value === value)?.label || value || '-';

// 0 is a valid value (e.g. 0% refund), so don't use truthiness checks
export const hasValue = (v) => v !== null && v !== undefined && v !== '';

export const toOptions = (arr) => arr.map((v) => ({ value: v, label: v }));